import { ModalComponent } from 'layout/ModalComponent';

export class ModalSpecification<TReturn = unknown, TState = unknown> {
  constructor(
    public readonly key: string,
    public readonly Modal: ModalComponent<TReturn, TState>,
    public readonly deepLinkable: boolean,
  ) {}
}
